import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threetwoseater() {


const cardData = {
keyword: "32 Seater Bus Rent in Pune",
headingDescription: "Ruturaj Enterprises offers reliable 32 Seater Bus Rent in Pune for large families, corporate teams, wedding groups, school excursions, tourist parties, event organizers, and other group travel requirements. With a spacious 32-seater option, passengers can travel together in one dedicated vehicle instead of coordinating multiple smaller vehicles, making it suitable for local sightseeing, airport transfers, picnics, celebrations, family vacations, and longer journeys from Pune.",
topPlaces: [
{
title: "Lonavala",
description: "Lonavala is one of the most convenient hill-station getaways from Pune, popular for waterfalls, forts, viewpoints, caves, and group outings. A 32 seater bus is especially useful for families, school groups, corporate teams, and friends planning a shared sightseeing or picnic trip."
},
{
title: "Bhimashankar",
description: "Bhimashankar attracts pilgrims, nature lovers, trekking groups, and families looking for a peaceful getaway surrounded by forested landscapes. Large groups traveling from Pune can use a 32 seater bus to keep everyone together while managing luggage and travel requirements comfortably."
},
{
title: "Matheran",
description: "Matheran is a scenic hill destination known for its viewpoints, pleasant surroundings, and peaceful atmosphere away from regular city traffic. A large-capacity bus is convenient for groups traveling from Pune who want coordinated transportation for a day trip or extended hill-station itinerary."
},
{
title: "Murud-Janjira",
description: "Murud-Janjira is an attractive coastal destination combining beaches, sea views, and the historic Janjira Fort experience. A 32 seater bus works well for large families, tourist groups, and friends planning a coastal journey from Pune with luggage and other trip essentials."
},
{
title: "Diveagar",
description: "Diveagar offers a relaxed coastal escape with beaches, greenery, and a quieter Konkan atmosphere, making it suitable for family holidays and group getaways. Larger groups can choose a 32 seater bus for convenient shared transportation throughout the journey from Pune."
},
{
title: "Lavasa",
description: "Lavasa is known for its lakeside surroundings, winding roads, scenic landscapes, and recreational activities, making it suitable for corporate outings and group leisure trips. A 32 seater bus allows a larger group to travel together for a planned day outing, picnic, or weekend program."
},
{
title: "Satara",
description: "Satara provides access to scenic attractions, waterfalls, forts, and natural viewpoints, making it suitable for family tours, school excursions, and group sightseeing. A 32 seater bus can accommodate larger parties traveling together from Pune for a coordinated travel itinerary."
},
{
title: "Bhandardara",
description: "Bhandardara is a popular nature getaway known for its lakes, mountains, waterfalls, and peaceful surroundings. Large groups planning camping trips, family vacations, corporate outings, or nature tours can benefit from traveling together in a dedicated 32 seater bus."
},
{
title: "Ganpatipule",
description: "Ganpatipule is a popular Konkan destination known for its beach, coastal scenery, and revered temple. A 32 seater bus provides a practical option for larger families, pilgrimage groups, and tourist parties traveling from Pune for a multi-day coastal journey."
},
{
title: "Panhala",
description: "Panhala is known for its historic fort, pleasant hill surroundings, and connection with Maharashtra's heritage. A 32 seater bus is suitable for school history trips, family outings, corporate excursions, and organized tourist groups looking for a comfortable shared journey from Pune."
}
],
services: [
{
name: "32 Seater Bus on Rent Pune",
description: "Ruturaj Enterprises provides 32 Seater Bus on Rent Pune services for large families, tourist groups, wedding parties, corporate teams, schools, event organizers, and other groups requiring spacious transportation. The vehicle can be planned for local sightseeing, airport transfers, picnics, functions, family tours, and longer journeys."
},
{
name: "32 Seater Bus Hire Pune",
description: "32 Seater Bus Hire Pune is a convenient solution for larger groups who prefer traveling together rather than arranging several smaller vehicles. It can be used for weddings, corporate programs, school excursions, family vacations, tourist tours, events, and group transportation requirements."
},
{
name: "32 Seater Bus Booking Pune",
description: "32 Seater Bus Booking Pune can be arranged for local trips, sightseeing programs, weekend getaways, multi-day tours, wedding functions, corporate events, and outstation journeys. Advance planning allows passenger capacity, pickup points, travel schedules, luggage requirements, and destinations to be coordinated more efficiently."
},
{
name: "32 Seater AC Bus Rental Pune",
description: "32 Seater AC Bus Rental Pune is suitable for groups looking for a more comfortable air-conditioned travel experience. It can be considered for long-distance family trips, corporate tours, school programs, weddings, airport transfers, tourist journeys, and travel during warmer seasons."
},
{
name: "32 Seater Luxury Bus on Rent Pune",
description: "32 Seater Luxury Bus on Rent Pune offers a premium-oriented transportation option for larger groups traveling for important occasions and special journeys. It is suitable for corporate events, wedding functions, family celebrations, private tours, tourist programs, and other occasions where additional comfort is preferred."
},
{
name: "32 Seater Bus for Outstation Pune",
description: "32 Seater Bus for Outstation Pune is suitable for large groups traveling from Pune to destinations across Maharashtra and neighboring regions. A dedicated bus helps passengers remain together while making it easier to coordinate luggage, scheduled breaks, sightseeing stops, and return travel."
},
{
name: "32 Seater Bus for Wedding Pune",
description: "32 Seater Bus for Wedding Pune is useful for transporting relatives and guests between homes, hotels, temples, marriage halls, banquet venues, and reception locations. One dedicated bus can simplify guest movement and help wedding organizers maintain a planned transportation schedule."
},
{
name: "32 Seater Bus for Corporate Events Pune",
description: "32 Seater Bus for Corporate Events Pune can support conferences, seminars, exhibitions, employee gatherings, training programs, team outings, and business events. Corporate groups can travel together between offices, hotels, event venues, and other scheduled locations with easier transportation coordination."
},
{
name: "32 Seater Bus for School Trips Pune",
description: "32 Seater Bus for School Trips Pune provides organized transportation for educational excursions, historical tours, nature visits, recreational outings, museums, and sightseeing programs. The larger capacity makes it useful for keeping students, teachers, and accompanying staff together during planned trips."
},
{
name: "32 Seater Bus for Group Travel Pune",
description: "32 Seater Bus for Group Travel Pune is designed for larger groups of friends, relatives, colleagues, tourists, community members, and organized travelers. Traveling in one dedicated vehicle can simplify pickup arrangements, route planning, passenger coordination, parking, and luggage management."
},
{
name: "32 Seater Bus for Family Trip Pune",
description: "32 Seater Bus for Family Trip Pune is suitable for extended families and relatives traveling together for holidays, pilgrimages, weekend getaways, and destination tours. Everyone can remain together in one vehicle while managing luggage, planned stops, and sightseeing requirements more conveniently."
},
{
name: "32 Seater Bus for Airport Pickup Pune",
description: "32 Seater Bus for Airport Pickup Pune is useful for large families, corporate teams, wedding groups, tourist parties, and organized travelers requiring transportation to or from Pune Airport. A dedicated bus allows passengers and luggage to be managed together instead of arranging several separate transfers."
},
{
name: "32 Seater Bus Near Me Pune",
description: "32 Seater Bus Near Me Pune is useful for travelers searching for a larger-capacity bus rental option within Pune. Ruturaj Enterprises caters to local sightseeing, airport transfers, family travel, weddings, corporate programs, school trips, picnics, events, and outstation requirements."
},
{
name: "Affordable 32 Seater Bus Rental Pune",
description: "Affordable 32 Seater Bus Rental Pune provides a practical shared transportation option for larger groups that want to avoid managing multiple smaller vehicles. It can be planned for family tours, corporate travel, school trips, weddings, picnics, events, sightseeing, and longer journeys."
},
{
name: "32 Seater Bus for Picnic Pune",
description: "32 Seater Bus for Picnic Pune is suitable for families, schools, offices, friends, community groups, and organizations planning recreational outings. The larger seating capacity allows the group to travel together while carrying bags, food, outdoor equipment, and other picnic essentials."
},
{
name: "32 Seater Bus for Marriage Function Pune",
description: "32 Seater Bus for Marriage Function Pune can be arranged for transporting guests and relatives during marriage ceremonies and related celebrations. It is convenient for scheduled movement between hotels, residences, temples, marriage halls, reception venues, and other locations included in the function itinerary."
},
{
name: "32 Seater Bus for Corporate Travel Pune",
description: "32 Seater Bus for Corporate Travel Pune provides shared transportation for employee groups attending meetings, training programs, business tours, client visits, company activities, and corporate gatherings. A dedicated bus helps teams follow a common route and reduces the complexity of coordinating multiple vehicles."
},
{
name: "32 Seater Bus for Event Pune",
description: "32 Seater Bus for Event Pune is suitable for conferences, exhibitions, cultural programs, private celebrations, corporate functions, social gatherings, and other events requiring group transportation. Organizers can coordinate movement between pickup locations, hotels, venues, and event destinations through one dedicated vehicle."
},
{
name: "32 Seater Bus for Tourist Trip Pune",
description: "32 Seater Bus for Tourist Trip Pune provides convenient transportation for larger tourist groups visiting several attractions and destinations. It can support sightseeing circuits, heritage tours, pilgrimage journeys, family holidays, weekend vacations, and organized tourist programs departing from Pune."
},
{
name: "32 Seater Bus for Outstation Tour Pune",
description: "32 Seater Bus for Outstation Tour Pune is a practical choice for large groups planning long-distance vacations, pilgrimage trips, destination tours, weekend getaways, and multi-day itineraries. A dedicated vehicle simplifies passenger coordination, luggage handling, scheduled breaks, sightseeing stops, and return arrangements."
},
{
name: "32 Seater AC Bus Hire Pune",
description: "32 Seater AC Bus Hire Pune offers an air-conditioned shared travel option for larger groups who prioritize comfort during their journey. It can be used for airport transfers, local sightseeing, weddings, corporate travel, school trips, family vacations, tourist tours, and outstation routes."
},
{
name: "32 Seater Luxury Bus Rental Pune",
description: "32 Seater Luxury Bus Rental Pune is suitable for groups looking for a premium-oriented transportation arrangement for special occasions and longer journeys. It can be considered for corporate events, wedding functions, private tours, family celebrations, tourist trips, and other group travel requirements."
}
],
tableData: [
["32 Seater Bus on Rent Pune", "32 Seater Bus Hire Pune"],
["32 Seater Bus Booking Pune", "32 Seater AC Bus Rental Pune"],
["32 Seater Luxury Bus on Rent Pune", "32 Seater Bus for Outstation Pune"],
["32 Seater Bus for Wedding Pune", "32 Seater Bus for Corporate Events Pune"],
["32 Seater Bus for School Trips Pune", "32 Seater Bus for Group Travel Pune"],
["32 Seater Bus for Family Trip Pune", "32 Seater Bus for Airport Pickup Pune"],
["32 Seater Bus Near Me Pune", "Affordable 32 Seater Bus Rental Pune"],
["32 Seater Bus for Picnic Pune", "32 Seater Bus for Marriage Function Pune"],
["32 Seater Bus for Corporate Travel Pune", "32 Seater Bus for Event Pune"],
["32 Seater Bus for Tourist Trip Pune", "32 Seater Bus for Outstation Tour Pune"],
["32 Seater AC Bus Hire Pune", "32 Seater Luxury Bus Rental Pune"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Capacity for Larger Parties",
WhyChoosedescription: "A 32 seater bus gives larger families, tourist groups, school parties, corporate teams, and wedding guests the advantage of traveling together. This arrangement can make long journeys and multi-location programs easier to coordinate."
},
{
WhyChooseheading: "One Vehicle for Better Coordination",
WhyChoosedescription: "Managing several cars or smaller vehicles can create challenges with arrival times, routes, parking, and passenger communication. A dedicated 32 seater bus keeps the group together and provides a simpler transportation arrangement."
},
{
WhyChooseheading: "Useful for Diverse Travel Plans",
WhyChoosedescription: "From local Pune sightseeing and airport transfers to weekend getaways and multi-day tours, the 32 seater format can support many different travel purposes. Groups can plan transportation according to their destination, passenger count, duration, and itinerary."
},
{
WhyChooseheading: "Practical Choice for Wedding Groups",
WhyChoosedescription: "Wedding celebrations often involve multiple venues and a substantial number of guests moving at different times. A 32 seater bus helps organizers arrange shared transportation between accommodation, ceremony venues, temples, banquet halls, and reception locations."
},
{
WhyChooseheading: "Suitable for Corporate Programs",
WhyChoosedescription: "Companies can use larger-capacity transportation for employee outings, conferences, training programs, exhibitions, meetings, and team activities. Keeping employees together in one vehicle can make scheduled group movement more manageable."
},
{
WhyChooseheading: "Options for Different Comfort Requirements",
WhyChoosedescription: "Different journeys have different comfort expectations, particularly when traveling for several hours or multiple days. AC and luxury-oriented 32 seater options provide flexibility for groups looking for a more comfortable travel arrangement."
},
{
WhyChooseheading: "Ideal for Educational and Recreational Trips",
WhyChoosedescription: "School excursions, picnics, nature trips, and recreational outings often involve many passengers traveling to the same destination. A 32 seater bus provides a convenient shared transportation arrangement for students, teachers, families, or group organizers."
},
{
WhyChooseheading: "Planned Travel from Pune",
WhyChoosedescription: "Ruturaj Enterprises supports 32 seater bus requirements for local and longer-distance journeys from Pune. Travel arrangements can be planned around pickup locations, destination, passenger capacity, journey duration, sightseeing requirements, events, and other group transportation needs."
}
]
};







const faqData = [
{
question: "Why choose Ruturaj Enterprises for a 32 Seater Bus rent in Pune?",
answer: "Ruturaj Enterprises provides 32 Seater Bus rental solutions for large groups that need to travel together conveniently. This seating capacity is well suited for corporate events, family functions, weddings, school and college excursions, pilgrimages, sightseeing tours, and outstation group journeys."
},
{
question: "Who can rent a 32 Seater Bus in Pune?",
answer: "Large families, companies, schools, colleges, wedding organizers, tour groups, social organizations, and event planners can rent a 32 Seater Bus when transportation is required for a sizable group. A single vehicle can make group movement easier to coordinate."
},
{
question: "Can a 32 Seater Bus be rented from Pune for outstation travel?",
answer: "Groups can arrange a 32 Seater Bus from Pune for journeys to destinations such as Mumbai, Goa, Shirdi, Nashik, Mahabaleshwar, Kolhapur, Konkan, and other locations. The rental can be planned around the group's route, travel dates, passenger count, and trip duration."
},
{
question: "Is a 32 Seater Bus suitable for large family tours?",
answer: "A 32 Seater Bus can be a practical choice for extended families traveling together for vacations, religious visits, reunions, weddings, and sightseeing programs. Keeping the entire group in one vehicle reduces the need to coordinate multiple cars during the journey."
},
{
question: "Can I hire a 32 Seater Bus for a wedding function in Pune?",
answer: "Wedding groups can use a 32 Seater Bus to transport relatives and guests between residences, hotels, wedding halls, reception venues, railway stations, and airports. The larger capacity makes it convenient when many guests need transportation for different functions."
},
{
question: "Can companies rent a 32 Seater Bus for corporate transportation?",
answer: "Corporate organizations may arrange a 32 Seater Bus for employee outings, conferences, seminars, training sessions, team-building programs, business events, industrial visits, and company tours. Group travel allows employees to move together according to the planned schedule."
},
{
question: "Is a 32 Seater Bus good for school and college trips?",
answer: "Educational institutions can choose a 32 Seater Bus for school picnics, college excursions, educational tours, industrial visits, cultural programs, and recreational outings. Dedicated group transportation can simplify passenger coordination and help the trip follow its planned itinerary."
},
{
question: "Can I rent a 32 Seater Bus for sightseeing around Pune?",
answer: "Groups planning Pune sightseeing or nearby excursions can consider a 32 Seater Bus when several passengers want to explore attractions together. Having one dedicated vehicle makes it easier for the group to move between multiple locations without arranging separate transportation."
},
{
question: "Can a 32 Seater Bus be used for airport and railway station transfers?",
answer: "A 32 Seater Bus can accommodate large groups traveling to or from Pune Airport and railway stations. It can be useful for wedding parties, corporate teams, tour groups, and families who want to coordinate their arrival, departure, and onward transportation through one group vehicle."
},
{
question: "How can I book a 32 Seater Bus rent in Pune?",
answer: "To arrange a 32 Seater Bus with Ruturaj Enterprises, share your pickup location, destination, travel date, passenger count, journey duration, and any special transportation requirements. Based on these details, the rental arrangement can be organized according to your group's travel plan."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Prakash Shinde",
feedback:
"We hired a 32 Seater Bus from Ruturaj Enterprises for a large family gathering and outstation trip from Pune. Keeping everyone together made the journey much easier to manage, particularly when moving between different locations. It was a suitable transportation option for our group size.",
rating: 5
},
{
id: 2,
name: "Miss. Riya Deshmukh",
feedback:
"Our college group used a 32 Seater Bus from Ruturaj Enterprises for an educational tour. Coordinating a large number of students was much simpler with everyone traveling in the same vehicle. The arrangement suited our itinerary and made the overall trip more convenient.",
rating: 5
}
];

















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/32-seater-bus-rent-in-pune.webp",
  "description":
    "32 Seater Bus Rent in Pune from Ruturaj Enterprises is a spacious group transportation solution for large families, friends, corporate teams, wedding groups, schools, colleges, tourists, institutions and organizations traveling together. 32 Seater Bus on Rent Pune is suitable for group tours, local sightseeing, family vacations, corporate transportation, wedding guest movement, school trips, college excursions, pilgrimage journeys, airport transfers and long-distance outstation travel. 32 Seater Bus Hire Pune provides an efficient way for larger groups to travel together in one vehicle rather than arranging multiple smaller vehicles, making group transportation easier to coordinate. 32 Seater Bus Booking Pune can be planned according to the pickup location, destination, travel dates, journey duration and passenger requirements. 32 Seater AC Bus Rental Pune offers a comfortable travel environment for warm-weather journeys and longer routes, while 32 Seater Luxury Bus on Rent Pune is suitable for premium group transportation during weddings, corporate events, special occasions, tours and organized travel programs. 32 Seater Bus for Outstation Pune can be arranged for popular destinations including Mumbai, Lonavala, Mahabaleshwar, Panchgani, Nashik, Shirdi, Kolhapur, Satara, Goa, Konkan, Alibaug, Matheran, Ratnagiri, Ganpatipule and other Maharashtra and interstate destinations. 32 Seater Bus for Wedding Pune is useful for transporting wedding guests between hotels, venues, reception locations, airports and railway stations, while 32 Seater Bus for Corporate Events Pune can support employee outings, conferences, seminars, exhibitions, meetings, training programs, business visits and team-building events. 32 Seater Bus for School Trips Pune is suitable for educational tours, school picnics, excursions and industrial visits, while 32 Seater Bus for Group Travel Pune and 32 Seater Bus for Family Trips Pune provide convenient transportation for larger tourist groups, family vacations, friends trips and customized road journeys. Additional arrangements can include airport pickup and drop, railway station transfers, hotel transportation, resort transfers, Pune Darshan, temple tours, pilgrimage trips, religious tours and local sightseeing. Pickup and drop services can be planned from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Pimpri, Chinchwad, Talegaon, Moshi, Bhosari and surrounding Pune areas. Ruturaj Enterprises supports flexible full-day, weekend, multi-day, local and outstation 32 Seater Bus rental requirements for family tours, corporate transportation, weddings, school trips, college tours, sightseeing, events, pilgrimages and customized large-group journeys from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/32-seater-bus-rent-in-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>32 Seater Bus Rent in Pune | 32 Seater Bus on Rent Pune | +91 9763381382</title>

  <meta
    name="description"
    content="32 Seater Bus Rent in Pune for large group travel, weddings, corporate events, school trips, family tours, sightseeing, airport transfers and outstation journeys with driver."
  />

  <meta
    name="keywords"
    content="32 Seater Bus on Rent Pune, 32 Seater Bus Hire Pune, 32 Seater Bus Booking Pune, 32 Seater AC Bus Rental Pune, 32 Seater Luxury Bus on Rent Pune, 32 Seater Bus for Outstation Pune, 32 Seater Bus for Wedding Pune, 32 Seater Bus for Corporate Events Pune, 32 Seater Bus for School Trips Pune, 32 Seater Bus for Group Travel Pune, 32 Seater Bus for Family Trips Pune, 32 Seater Bus Rent in Pune, 32 Seater Bus Rental Pune, 32 Seater Bus Hire in Pune, 32 Seater Bus Booking in Pune, 32 Seater Bus with Driver Pune, 32 Seater Private Bus Pune, 32 Seater AC Bus on Rent Pune, 32 Seater AC Bus Hire Pune, 32 Seater AC Bus Booking Pune, 32 Seater Luxury Bus Rental Pune, 32 Seater Luxury Bus Hire Pune, Premium 32 Seater Bus Pune, Affordable 32 Seater Bus Rental Pune, 32 Seater Bus for Large Group Pune, 32 Seater Bus for Group Tour Pune, 32 Seater Bus for Friends Trip Pune, 32 Seater Bus for Family Tour Pune, 32 Seater Bus for Family Vacation Pune, 32 Seater Bus for Weekend Trip Pune, 32 Seater Bus for Holiday Trip Pune, 32 Seater Bus for Road Trip Pune, 32 Seater Bus for Sightseeing Pune, 32 Seater Bus for Local Sightseeing Pune, 32 Seater Bus for Pune Darshan, 32 Seater Bus for Maharashtra Tour Pune, 32 Seater Bus for Goa Trip Pune, 32 Seater Bus for Mumbai Trip Pune, 32 Seater Bus for Lonavala Trip Pune, 32 Seater Bus for Mahabaleshwar Trip Pune, 32 Seater Bus for Panchgani Trip Pune, 32 Seater Bus for Nashik Trip Pune, 32 Seater Bus for Shirdi Trip Pune, 32 Seater Bus for Kolhapur Trip Pune, 32 Seater Bus for Satara Trip Pune, 32 Seater Bus for Konkan Trip Pune, 32 Seater Bus for Alibaug Trip Pune, 32 Seater Bus for Matheran Trip Pune, 32 Seater Bus for Ratnagiri Trip Pune, 32 Seater Bus for Ganpatipule Trip Pune, 32 Seater Bus for Dapoli Trip Pune, 32 Seater Bus for Outstation Trip Pune, 32 Seater Bus Outstation Rental Pune, 32 Seater Bus One Way Pune, 32 Seater Bus Round Trip Pune, 32 Seater Bus Full Day Rental Pune, 32 Seater Bus Multi Day Rental Pune, 32 Seater Bus Weekend Rental Pune, 32 Seater Bus Tour Package Pune, 32 Seater Bus Sightseeing Package Pune, 32 Seater Bus Family Tour Package Pune, 32 Seater Bus Group Tour Package Pune, 32 Seater Bus Corporate Tour Pune, 32 Seater Bus Corporate Travel Pune, 32 Seater Bus for Corporate Outing Pune, 32 Seater Bus for Employee Transportation Pune, 32 Seater Bus for Office Trip Pune, 32 Seater Bus for Company Event Pune, 32 Seater Bus for Business Travel Pune, 32 Seater Bus for Conference Pune, 32 Seater Bus for Seminar Pune, 32 Seater Bus for Exhibition Pune, 32 Seater Bus for Training Pune, 32 Seater Bus for Industrial Visit Pune, 32 Seater Bus for Wedding Guest Pune, 32 Seater Bus for Marriage Pune, 32 Seater Bus for Reception Pune, 32 Seater Bus for Destination Wedding Pune, 32 Seater Bus for Wedding Guest Transportation Pune, 32 Seater Bus for Event Transportation Pune, 32 Seater Bus for Airport Transfer Pune, 32 Seater Bus for Airport Pickup Pune, 32 Seater Bus for Airport Drop Pune, 32 Seater Bus for Pune Airport, 32 Seater Bus for Railway Station Transfer Pune, 32 Seater Bus for Pune Railway Station, 32 Seater Bus for Hotel Transfer Pune, 32 Seater Bus for Resort Transfer Pune, 32 Seater Bus for Guest Pickup Pune, 32 Seater Bus for Guest Drop Pune, 32 Seater Bus for School Tour Pune, 32 Seater Bus for School Picnic Pune, 32 Seater Bus for College Trip Pune, 32 Seater Bus for College Tour Pune, 32 Seater Bus for Student Group Pune, 32 Seater Bus for Temple Tour Pune, 32 Seater Bus for Pilgrimage Pune, 32 Seater Bus for Religious Tour Pune, 32 Seater Bus for Tourist Group Pune, 32 Seater Bus for Group Transportation Pune, 32 Seater Bus for Family Transportation Pune, 32 Seater Bus for Corporate Transportation Pune, 32 Seater Bus for Event Transportation Pune, 32 Seater Bus Rental Near Pune, 32 Seater Bus Hire Near Pune, 32 Seater Bus Booking Near Pune, 32 Seater Bus Rental Pimpri Chinchwad, 32 Seater Bus Hire Pimpri Chinchwad, 32 Seater Bus Rental Wakad, 32 Seater Bus Rental Hinjewadi, 32 Seater Bus Rental Kothrud, 32 Seater Bus Rental Baner, 32 Seater Bus Rental Aundh, 32 Seater Bus Rental Viman Nagar, 32 Seater Bus Rental Kharadi, 32 Seater Bus Rental Hadapsar, 32 Seater Bus Rental Kondhwa, 32 Seater Bus Rental Katraj, 32 Seater Bus Rental Shivajinagar, 32 Seater Bus Rental Swargate, 32 Seater Bus Rental Pimpri, 32 Seater Bus Rental Chinchwad, 32 Seater Bus Rental Talegaon, 32 Seater Bus Rental Moshi, 32 Seater Bus Rental Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Threetwoseater ;